import { useTheme } from "@mui/material";
import React from "react";

type ExperienceTitleCellProps = {
  value: string;
  isInternal: boolean;
};

export const ExperienceTitleCell: React.FC<ExperienceTitleCellProps> =
  React.memo(({ value }) => {
    const theme = useTheme();

    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          width: "100%",
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontWeight: 500,
          color: theme.colors.text[5],
        }}
      >
        {value}
      </span>
    );
  });

ExperienceTitleCell.displayName = "ExperienceTitleCell";
